import { ref, get } from 'firebase/database';
import { db } from '../config/firebase';
import { SHARE_CODE_LENGTH } from '../config/constants';

export function generateShareCode(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length: SHARE_CODE_LENGTH }, () =>
    chars[Math.floor(Math.random() * chars.length)]
  ).join('');
}

export async function lookupShareCode(shareCode: string): Promise<string | null> {
  const snapshot = await get(ref(db, `shareCodes/${shareCode}`));
  if (!snapshot.exists()) return null;
  return snapshot.val().tripId;
}

export async function createCheckoutSession(tripId: string): Promise<string> {
  const response = await fetch('/api/create-checkout-session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tripId }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error('Checkout session error:', response.status, errorData);
    throw new Error(errorData.error || `Server error: ${response.status}`);
  }

  const data = await response.json();
  if (!data.url) {
    throw new Error('No checkout URL returned');
  }
  return data.url;
}
